// import React, { useEffect } from "react";
// import aboutUs from "../assets/img/about-us.png";
// import aboutVegetables from "../assets/img/about-vegetables.png";
// import men1 from "../assets/img/men-1.png";
// import men2 from "../assets/img/men-2.png";
// import men3 from "../assets/img/men-3.png";
// import women1 from "../assets/img/women-1.png";
// import women2 from "../assets/img/women-2.png";
// import women3 from "../assets/img/women-3.png";
// import { useSettings } from "../context/SettingsContext";

// const About = () => {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   const settings = useSettings();
//   return (
//     <div className="bg-gray-50">
//       <div className="flex justify-center py-10 lg:py-20 bg-page-header-bg bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom bg-page-header ">
//         <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
//           <div className="w-full flex justify-center flex-col relative">
//             <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-center text-black">
//               About US
//             </h2>
//           </div>
//         </div>
//       </div>
//       <div className="bg-white">
//         <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
//           <div className="grid grid-flow-row lg:grid-cols-2 gap-4 lg:gap-16 ">
//             <div>
//               <h3 className="text-xl lg:text-3xl mb-2  font-semibold">
//                 Welcome to our {settings?.shop_name}
//               </h3>
//               <div className="mt-3 text-base opacity-90 leading-7">
//                 <p className="mb-4">
//                   Holisticly seize parallel metrics and functional ROI.
//                   Seamlessly revolutionize error-free internal or "organic"
//                   sources before effective scenarios. Progressively incentivize
//                   state of the art applications for efficient intellectual
//                   capital. Credibly leverage existing distinctive mindshare
//                   through cutting-edge schemas. Proactively procrastinate team
//                   building paradigms coordinate client-centric total transparent
//                   internal.
//                 </p>

//                 <p>
//                   Dynamically embrace diverse customer service and installed
//                   base paradigms. Credibly seize enterprise-wide experiences for
//                   end-to-end data. Professionally brand flexible alignments and
//                   cost effective architectures. Enthusiastically incentivize
//                   seamless communities with seamlessly facilitate revolutionary
//                   metrics with strategic theme areas.
//                 </p>
//               </div>
//               {/* <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-2 xl:gap-6 mt-8">
//                 <div className="p-8 bg-indigo-50 shadow-sm rounded-lg">
//                   <span className="text-3xl block font-extrabold  mb-4 text-gray-800">
//                     10K
//                   </span>
//                   <h4 className="text-lg font-bold mb-1">Listed Products</h4>
//                   <p className="mb-0 opacity-90 leading-7">
//                     Dynamically morph team driven partnerships after vertical.
//                   </p>
//                 </div>
//                 <div className="p-8 bg-indigo-50 shadow-sm rounded-lg">
//                   <span className="text-3xl block font-extrabold  mb-4 text-gray-800">
//                     8K
//                   </span>
//                   <h4 className="text-lg  font-bold mb-1">Lovely Customer</h4>
//                   <p className="mb-0 opacity-90 leading-7">
//                     Competently productize virtual models without performance.
//                   </p>
//                 </div>
//               </div> */}
//             </div>
//             <div className="mt-10 lg:mt-0 ">
//               <span
//                 style={{
//                   boxSizing: "border-box",
//                   display: "inline-block",
//                   overflow: "hidden",
//                   width: "initial",
//                   height: "initial",
//                   background: "none",
//                   opacity: "1",
//                   border: "0",
//                   margin: "0",
//                   padding: "0",
//                   position: "relative",
//                   maxWidth: "100%",
//                 }}
//               >
//                 <img
//                   style={{
//                     display: "block",
//                     maxWidth: "100%",
//                     width: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                   }}
//                   src={aboutUs}
//                 />
//               </span>
//             </div>
//           </div>
//           {/* <div className="mt-10 lg:mt-16 text-base opacity-90 leading-7">
//             <p className="mb-4">
//               Holisticly seize parallel metrics and functional ROI. Seamlessly
//               revolutionize error-free internal or "organic" sources before
//               effective scenarios. Progressively incentivize state of the art
//               applications for efficient intellectual capital. Credibly leverage
//               existing distinctive mindshare through cutting-edge schemas.
//               Proactively procrastinate team building paradigms coordinate
//               client-centric total transparent internal. Energistically
//               reconceptualize global leadership for high-quality networks.
//               Credibly restore an expanded array of systems rather than accurate
//               results. Collaboratively synergize backend bandwidth without 24/7
//               functionalities. Credibly utilize proactive ideas whereas
//               cross-media core competencies. Uniquely maximize professional best
//               practices through resource maximizing services. Conveniently
//               architect cross-unit web services for e-business imperatives.
//             </p>
//             <p>
//               Appropriately visualize market-driven data before one-to-one
//               scenarios. Collaboratively productize multifunctional ROI through
//               intuitive supply chains. Enthusiastically seize revolutionary
//               value and process-centric services. Competently harness intuitive
//               information after interoperable markets. Interactively
//               revolutionize future-proof value before granular sources.
//               Dynamically embrace diverse customer service and installed base
//               paradigms. Credibly seize enterprise-wide experiences for
//               end-to-end data. Professionally brand flexible alignments and cost
//               effective architectures. Enthusiastically incentivize seamless
//               communities with seamlessly facilitate revolutionary metrics with
//               strategic theme areas.
//             </p>
//           </div> */}
//           {/* <div className="mt-10 lg:mt-12 flex flex-col sm:grid gap-4">
//             <span
//               style={{
//                 boxSizing: "border-box",
//                 display: "inline-block",
//                 overflow: "hidden",
//                 width: "initial",
//                 height: "initial",
//                 background: "none",
//                 opacity: "1",
//                 border: "0",
//                 margin: "0",
//                 padding: "0",
//                 position: "relative",
//                 maxWidth: "100%",
//               }}
//             >
//               <span
//                 style={{
//                   boxSizing: "border-box",
//                   display: "block",
//                   width: "initial",
//                   height: "initial",
//                   background: "none",
//                 }}
//               >
//                 <img
//                   style={{
//                     display: "block",
//                     maxWidth: "100%",
//                     width: "initial",
//                     height: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                     boxSizing: "border-box",
//                   }}
//                   className="block rounded-lg"
//                   src={aboutVegetables}
//                 />
//               </span>
//             </span>
//           </div> */}
//         </div>
//         {/* <div className="bg-gray-50 lg:py-20 py-10">
//           <div className="max-w-screen-2xl mx-auto px-3 sm:px-10">
//             <div className="relative flex flex-col sm:flex-row sm:items-end justify-between mb-8">
//               <div className="max-w-2xl">
//                 <h3 className="text-xl lg:text-3xl mb-2  font-semibold">
//                   Our Founder
//                 </h3>
//                 <p className="mt-2 md:mt-3 font-normal block text-base">
//                   We’re impartial and independent, and every day we create
//                   distinctive, world-class reintermediate backend supply
//                   programmes.
//                 </p>
//               </div>
//             </div>
//             <div className="grid sm:grid-cols-2 gap-x-5 gap-y-8 lg:grid-cols-6 xl:gap-x-8 ">
//               <div className="max-w-sm">
//                 <span
//                   style={{
//                     boxSizing: "border-box",
//                     display: "inline-block",
//                     overflow: "hidden",
//                     width: "initial",
//                     height: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                     position: "relative",
//                     maxWidth: "100%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       boxSizing: "border-box",
//                       display: "block",
//                       width: "initial",
//                       height: "initial",
//                       background: "none",
//                       opacity: "1",
//                       border: "0",
//                       margin: "0",
//                       padding: "0",
//                       maxWidth: "100%",
//                     }}
//                   >
//                     <img
//                       className="block rounded-lg"
//                       style={{
//                         display: "bolck",
//                         maxWidth: "100%",
//                         width: "initial",
//                         height: "initial",
//                         background: "none",
//                         opacity: "1",
//                         border: "0",
//                         margin: "0",
//                         padding: "0",
//                       }}
//                       src={men1}
//                     />
//                   </span>
//                 </span>
//                 <div className="py-4">
//                   <h5 className="text-lg font-semibold ">Niamh Shea</h5>
//                   <span className="opacity-75 text-sm">
//                     Co-founder &amp; Executive
//                   </span>
//                 </div>
//               </div>
//               <div className="max-w-sm">
//                 <span
//                   style={{
//                     boxSizing: "border-box",
//                     display: "inline-block",
//                     overflow: "hidden",
//                     width: "initial",
//                     height: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                     position: "relative",
//                     maxWidth: "100%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       boxSizing: "border-box",
//                       display: "block",
//                       width: "initial",
//                       height: "initial",
//                       background: "none",
//                       opacity: "1",
//                       border: "0",
//                       margin: "0",
//                       padding: "0",
//                       maxWidth: "100%",
//                     }}
//                   >
//                     <img
//                       className="block rounded-lg"
//                       style={{
//                         display: "bolck",
//                         maxWidth: "100%",
//                         width: "initial",
//                         height: "initial",
//                         background: "none",
//                         opacity: "1",
//                         border: "0",
//                         margin: "0",
//                         padding: "0",
//                       }}
//                       src={women1}
//                     />
//                   </span>
//                 </span>
//                 <div className="py-4">
//                   <h5 className="text-lg font-semibold ">Orla Dwyer</h5>
//                   <span className="opacity-75 text-sm">Chief Executive</span>
//                 </div>
//               </div>
//               <div className="max-w-sm">
//                 <span
//                   style={{
//                     boxSizing: "border-box",
//                     display: "inline-block",
//                     overflow: "hidden",
//                     width: "initial",
//                     height: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                     position: "relative",
//                     maxWidth: "100%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       boxSizing: "border-box",
//                       display: "block",
//                       width: "initial",
//                       height: "initial",
//                       background: "none",
//                       opacity: "1",
//                       border: "0",
//                       margin: "0",
//                       padding: "0",
//                       maxWidth: "100%",
//                     }}
//                   >
//                     <img
//                       className="block rounded-lg"
//                       style={{
//                         display: "bolck",
//                         maxWidth: "100%",
//                         width: "initial",
//                         height: "initial",
//                         background: "none",
//                         opacity: "1",
//                         border: "0",
//                         margin: "0",
//                         padding: "0",
//                       }}
//                       src={men2}
//                     />
//                   </span>
//                 </span>
//                 <div className="py-4">
//                   <h5 className="text-lg font-semibold ">Danien James</h5>
//                   <span className="opacity-75 text-sm">
//                     Co-founder, Chairman
//                   </span>
//                 </div>
//               </div>
//               <div className="max-w-sm">
//                 <span
//                   style={{
//                     boxSizing: "border-box",
//                     display: "inline-block",
//                     overflow: "hidden",
//                     width: "initial",
//                     height: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                     position: "relative",
//                     maxWidth: "100%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       boxSizing: "border-box",
//                       display: "block",
//                       width: "initial",
//                       height: "initial",
//                       background: "none",
//                       opacity: "1",
//                       border: "0",
//                       margin: "0",
//                       padding: "0",
//                       maxWidth: "100%",
//                     }}
//                   >
//                     <img
//                       className="block rounded-lg"
//                       style={{
//                         display: "bolck",
//                         maxWidth: "100%",
//                         width: "initial",
//                         height: "initial",
//                         background: "none",
//                         opacity: "1",
//                         border: "0",
//                         margin: "0",
//                         padding: "0",
//                       }}
//                       src={women2}
//                     />
//                   </span>
//                 </span>
//                 <div className="py-4">
//                   <h5 className="text-lg font-semibold ">Dara Frazier</h5>
//                   <span className="opacity-75 text-sm">
//                     Chief Strategy Officer
//                   </span>
//                 </div>
//               </div>
//               <div className="max-w-sm">
//                 <span
//                   style={{
//                     boxSizing: "border-box",
//                     display: "inline-block",
//                     overflow: "hidden",
//                     width: "initial",
//                     height: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                     position: "relative",
//                     maxWidth: "100%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       boxSizing: "border-box",
//                       display: "block",
//                       width: "initial",
//                       height: "initial",
//                       background: "none",
//                       opacity: "1",
//                       border: "0",
//                       margin: "0",
//                       padding: "0",
//                       maxWidth: "100%",
//                     }}
//                   >
//                     <img
//                       className="block rounded-lg"
//                       style={{
//                         display: "bolck",
//                         maxWidth: "100%",
//                         width: "initial",
//                         height: "initial",
//                         background: "none",
//                         opacity: "1",
//                         border: "0",
//                         margin: "0",
//                         padding: "0",
//                       }}
//                       src={women3}
//                     />
//                   </span>
//                 </span>
//                 <div className="py-4">
//                   <h5 className="text-lg font-semibold ">Glenda Arvidson</h5>
//                   <span className="opacity-75 text-sm">HR Officer</span>
//                 </div>
//               </div>
//               <div className="max-w-sm">
//                 <span
//                   style={{
//                     boxSizing: "border-box",
//                     display: "inline-block",
//                     overflow: "hidden",
//                     width: "initial",
//                     height: "initial",
//                     background: "none",
//                     opacity: "1",
//                     border: "0",
//                     margin: "0",
//                     padding: "0",
//                     position: "relative",
//                     maxWidth: "100%",
//                   }}
//                 >
//                   <span
//                     style={{
//                       boxSizing: "border-box",
//                       display: "block",
//                       width: "initial",
//                       height: "initial",
//                       background: "none",
//                       opacity: "1",
//                       border: "0",
//                       margin: "0",
//                       padding: "0",
//                       maxWidth: "100%",
//                     }}
//                   >
//                     <img
//                       className="block rounded-lg"
//                       style={{
//                         display: "bolck",
//                         maxWidth: "100%",
//                         width: "initial",
//                         height: "initial",
//                         background: "none",
//                         opacity: "1",
//                         border: "0",
//                         margin: "0",
//                         padding: "0",
//                       }}
//                       src={men3}
//                     />
//                   </span>
//                 </span>
//                 <div className="py-4">
//                   <h5 className="text-lg font-semibold ">Melvin Davis</h5>
//                   <span className="opacity-75 text-sm">Lead Developer</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div> */}
//       </div>
//     </div>
//   );
// }

// export default About;

import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import aboutUs from "../assets/img/about-us.png";
import { useTranslation } from "react-i18next";
import { useSettings } from "../context/SettingsContext";

const aboutContent = {
  en: {
    title: "About Us",
    welcomePrefix: "Welcome to",
    subtitle: "Your trusted online grocery destination",
    paragraphOne:
      "We are a modern grocery eCommerce platform created to make your everyday shopping easier, faster, and more convenient. From fresh fruits and vegetables to dairy products, snacks, beverages, household items, and daily essentials, we bring quality groceries directly to your doorstep.",
    paragraphTwo:
      "Our goal is to save your time and provide a smooth shopping experience with fresh products, fair prices, secure payment, and reliable delivery. We carefully select our products so that every customer can shop with confidence.",
    paragraphThree:
      "Whether you are shopping for your family, home, or business, we are here to serve you with care, honesty, and convenience. We believe grocery shopping should be simple, stress-free, and accessible for everyone.",
    tagline: "Shop fresh. Save time. Live better.",
    featureOneTitle: "Fresh Products",
    featureOneDesc: "Carefully selected groceries for your daily needs.",
    featureTwoTitle: "Fast Delivery",
    featureTwoDesc: "Quick and reliable delivery at your doorstep.",
    featureThreeTitle: "Easy Shopping",
    featureThreeDesc: "Simple ordering, secure payment, and friendly support.",
    imageAlt: "About grocery ecommerce",
  },

  bn: {
    title: "আমাদের সম্পর্কে",
    welcomePrefix: "স্বাগতম",
    subtitle: "আপনার বিশ্বস্ত অনলাইন গ্রোসারি গন্তব্য",
    paragraphOne:
      "আমরা একটি আধুনিক গ্রোসারি ই-কমার্স প্ল্যাটফর্ম, যেখানে আপনার প্রতিদিনের বাজার করা হবে আরও সহজ, দ্রুত এবং সুবিধাজনক। তাজা ফল, সবজি, দুগ্ধজাত পণ্য, স্ন্যাকস, পানীয়, ঘরের প্রয়োজনীয় সামগ্রীসহ দৈনন্দিন প্রয়োজনীয় পণ্য আমরা পৌঁছে দিই আপনার দোরগোড়ায়।",
    paragraphTwo:
      "আমাদের লক্ষ্য হলো আপনার সময় বাঁচানো এবং একটি সুন্দর শপিং অভিজ্ঞতা নিশ্চিত করা। আমরা তাজা পণ্য, সঠিক মূল্য, নিরাপদ পেমেন্ট এবং নির্ভরযোগ্য ডেলিভারির মাধ্যমে গ্রাহকদের সন্তুষ্টি নিশ্চিত করতে কাজ করি।",
    paragraphThree:
      "পরিবার, বাসা বা ব্যবসার জন্য কেনাকাটা—যেকোনো প্রয়োজনেই আমরা আপনার পাশে আছি। আমরা বিশ্বাস করি, গ্রোসারি শপিং হওয়া উচিত সহজ, ঝামেলাহীন এবং সবার জন্য সুবিধাজনক।",
    tagline: "তাজা কিনুন। সময় বাঁচান। জীবন করুন আরও সহজ।",
    featureOneTitle: "তাজা পণ্য",
    featureOneDesc: "আপনার দৈনন্দিন প্রয়োজনের জন্য বাছাইকৃত মানসম্মত পণ্য।",
    featureTwoTitle: "দ্রুত ডেলিভারি",
    featureTwoDesc: "আপনার দোরগোড়ায় দ্রুত এবং নির্ভরযোগ্য ডেলিভারি।",
    featureThreeTitle: "সহজ কেনাকাটা",
    featureThreeDesc: "সহজ অর্ডার, নিরাপদ পেমেন্ট এবং আন্তরিক সাপোর্ট।",
    imageAlt: "গ্রোসারি ই-কমার্স সম্পর্কে",
  },
};

const About = () => {
  const { t, i18n } = useTranslation();
  const settings = useSettings();
  const isBn = i18n.language === "bn";

  const content = isBn ? aboutContent.bn : aboutContent.en;

  const shopName = isBn
    ? settings?.shop_name_bn || settings?.shop_name || "our grocery shop"
    : settings?.shop_name_en || settings?.shop_name || "our grocery shop";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      <Helmet>
        <title>About Us | Palli Market - Your Trusted Online Grocery</title>
        <meta name="description" content="Learn about Palli Market - your trusted online grocery destination. We deliver fresh products, daily essentials and more at the best prices with fast delivery." />
        <link rel="canonical" href="https://pallimarket.bd/about-us" />
        <meta property="og:title" content="About Us | Palli Market" />
        <meta property="og:description" content="Learn about Palli Market - your trusted online grocery destination. We deliver fresh products, daily essentials and more at the best prices with fast delivery." />
        <meta property="og:url" content="https://pallimarket.bd/about-us" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="flex justify-center py-10 lg:py-20 bg-page-header-bg bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom bg-page-header">
        <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
          <div className="w-full flex justify-center flex-col relative">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-center text-black">
              {t("about.title", content.title)}
            </h2>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
          <div className="grid grid-flow-row lg:grid-cols-2 gap-4 lg:gap-16">
            <div>
              <span className="inline-block text-emerald-500 font-semibold mb-2">
                {content.subtitle}
              </span>

              <h3 className="text-xl lg:text-3xl mb-4 font-semibold text-gray-900">
                {content.welcomePrefix} {shopName}
              </h3>

              <div className="mt-3 text-base opacity-90 leading-7 text-gray-700">
                <p className="mb-4">{content.paragraphOne}</p>
                <p className="mb-4">{content.paragraphTwo}</p>
                <p className="mb-4">{content.paragraphThree}</p>

                <p className="font-semibold text-emerald-600">
                  {content.tagline}
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-4 mt-8">
                <div className="p-6 bg-emerald-50 rounded-lg border border-emerald-100">
                  <span className="text-3xl block mb-3">🥬</span>
                  <h4 className="text-lg font-bold mb-1 text-gray-800">
                    {content.featureOneTitle}
                  </h4>
                  <p className="mb-0 opacity-90 leading-6 text-sm text-gray-600">
                    {content.featureOneDesc}
                  </p>
                </div>

                <div className="p-6 bg-emerald-50 rounded-lg border border-emerald-100">
                  <span className="text-3xl block mb-3">🚚</span>
                  <h4 className="text-lg font-bold mb-1 text-gray-800">
                    {content.featureTwoTitle}
                  </h4>
                  <p className="mb-0 opacity-90 leading-6 text-sm text-gray-600">
                    {content.featureTwoDesc}
                  </p>
                </div>

                <div className="p-6 bg-emerald-50 rounded-lg border border-emerald-100">
                  <span className="text-3xl block mb-3">🛒</span>
                  <h4 className="text-lg font-bold mb-1 text-gray-800">
                    {content.featureThreeTitle}
                  </h4>
                  <p className="mb-0 opacity-90 leading-6 text-sm text-gray-600">
                    {content.featureThreeDesc}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 lg:mt-0 flex items-center justify-center">
              <span
                style={{
                  boxSizing: "border-box",
                  display: "inline-block",
                  overflow: "hidden",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: "1",
                  border: "0",
                  margin: "0",
                  padding: "0",
                  position: "relative",
                  maxWidth: "100%",
                }}
              >
                <img
                  style={{
                    display: "block",
                    maxWidth: "100%",
                    width: "initial",
                    background: "none",
                    opacity: "1",
                    border: "0",
                    margin: "0",
                    padding: "0",
                  }}
                  src={aboutUs}
                  alt={content.imageAlt}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;